export const isMobileQuery = '991px';

export const isInStandaloneMode = () =>
// @ts-ignore
(window.matchMedia('(display-mode: standalone)').matches) || (window.navigator.standalone) || document.referrer.includes('android-app://');
